// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"262":"a5d241b3","626":"3cfaf594"}[chunkId] + ".chunk.css";
};